module.exports = __webpack_public_path__ + "static/media/youtube.25ec6f40.png";